import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Public
export async function submitQuote(payload) {
  const { data } = await api.post("/quotes", payload);
  return data;
}
export async function submitConsultation(payload) {
  const { data } = await api.post("/consultations", payload);
  return data;
}
export async function uploadPhotos(files) {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  const { data } = await axios.post(`${API}/uploads`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
    timeout: 60000,
  });
  return data.files.map((f) => ({ ...f, absoluteUrl: `${BACKEND_URL}${f.url}` }));
}

// Auth
export async function login(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}
export async function me() {
  const { data } = await api.get("/auth/me");
  return data;
}
export async function logout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

// Admin
export async function fetchAdminSummary() {
  const { data } = await api.get("/admin/summary");
  return data;
}
export async function fetchQuotes() {
  const { data } = await api.get("/admin/quotes");
  return data;
}
export async function fetchQuote(id) {
  const { data } = await api.get(`/admin/quotes/${id}`);
  return data;
}
export async function fetchConsultations() {
  const { data } = await api.get("/admin/consultations");
  return data;
}
export async function fetchConsultation(id) {
  const { data } = await api.get(`/admin/consultations/${id}`);
  return data;
}
export async function sendEstimate(targetType, id, payload) {
  const route = targetType === "quote"
    ? `/admin/quotes/${id}/estimate`
    : `/admin/consultations/${id}/estimate`;
  const { data } = await api.post(route, payload);
  return data;
}

// Absolute URL helper for photos stored as /api/uploads/...
export function absoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) return pathOrUrl;
  return `${BACKEND_URL}${pathOrUrl}`;
}
